import { db } from './firebase'

export const ACTIVE_COMPANY_STORAGE_KEY = 'kne.activeCompanyUid'

export function getStoredActiveCompanyUid () {
  try {
    return window.localStorage.getItem(ACTIVE_COMPANY_STORAGE_KEY)
  } catch (error) {
    return ''
  }
}

export function setStoredActiveCompanyUid (companyUID) {
  try {
    if (companyUID) window.localStorage.setItem(ACTIVE_COMPANY_STORAGE_KEY, companyUID)
    else window.localStorage.removeItem(ACTIVE_COMPANY_STORAGE_KEY)
  } catch (error) {}
}

export function normalizeSisterCompanies (sisterCompanies) {
  if (!sisterCompanies) return []

  if (Array.isArray(sisterCompanies)) {
    return sisterCompanies
      .map((company) => {
        if (!company) return null
        if (typeof company === 'string') {
          return { uid: company, companyName: company }
        }
        const uid = company.uid || company.UID || company.companyUID || company.companyUid || company.company || company.id || company.key || company['.key']
        if (!uid) {
          const companyKeys = Object.keys(company)
          if (companyKeys.length === 1 && company[companyKeys[0]] && typeof company[companyKeys[0]] === 'object') {
            const nestedCompany = company[companyKeys[0]]
            return {
              uid: companyKeys[0],
              companyName: nestedCompany.companyName || nestedCompany.name || '',
              isUpdateSeen: nestedCompany.isUpdateSeen,
              role: nestedCompany.role,
              isPrimary: false
            }
          }
        }
        if (!uid) return null
        return {
          uid,
          companyName: company.companyName || company.name || '',
          isUpdateSeen: company.isUpdateSeen,
          role: company.role,
          isPrimary: false
        }
      })
      .filter(company => company && company.uid)
  }

  return Object.keys(sisterCompanies)
    .map((uid) => {
      const company = sisterCompanies[uid]
      if (!company) return null
      if (typeof company === 'string') {
        return {
          uid,
          companyName: company,
          isPrimary: false
        }
      }
      return {
        uid,
        companyName: company.companyName || company.name || '',
        isUpdateSeen: company.isUpdateSeen,
        role: company.role,
        isPrimary: false
      }
    })
    .filter(company => company && company.uid)
}

export function getCompanyAccessList (authorization) {
  if (!authorization || !authorization.company) return []

  const primaryCompany = {
    uid: authorization.company,
    companyName: authorization.companyName || authorization.name || '',
    isUpdateSeen: authorization.isUpdateSeen,
    role: authorization.role,
    isPrimary: true
  }

  const sisterCompanies = normalizeSisterCompanies(authorization.sisterCompanies)
    .filter(company => company.uid !== authorization.company)

  return [primaryCompany].concat(sisterCompanies)
}

export function getInitialCompanyAccess (authorization) {
  const companies = getCompanyAccessList(authorization)
  if (!companies.length) return null

  const storedCompanyUID = getStoredActiveCompanyUid()
  return companies.find(company => company.uid === storedCompanyUID) || companies[0]
}

export function buildAuthorizationForCompany (authorization, company) {
  if (!authorization || !company) return authorization

  const isSisterCompany = company.uid !== authorization.company
  return {
    ...authorization,
    company: company.uid,
    role: company.role || authorization.role,
    isUpdateSeen: typeof company.isUpdateSeen === 'boolean' ? company.isUpdateSeen : authorization.isUpdateSeen,
    activeCompanyName: company.companyName || '',
    activeCompanyUid: company.uid,
    primaryCompany: authorization.company,
    isSisterCompany
  }
}

export async function loadCompanyOptions (authorization) {
  const companies = getCompanyAccessList(authorization)

  return Promise.all(companies.map(async (company) => {
    if (company.companyName) return company

    try {
      const snapshot = await db.ref('users/transporters').child(company.uid).once('value')
      const companyInfo = snapshot.val() || {}
      return {
        ...company,
        companyName: companyInfo.companyName || companyInfo.name || company.uid
      }
    } catch (error) {
      return {
        ...company,
        companyName: company.uid
      }
    }
  }))
}
